const CHANNEL_NAME = 'safe-minds-child-access-channel';

type BroadcastChannelLike = {
  postMessage: (value: unknown) => void;
  close: () => void;
  onmessage: ((event: BroadcastChannelMessageEvent) => void) | null;
};

type BroadcastChannelMessageEvent = { data: unknown };

export type ChildAccessEvent =
  | {
      type: 'REVOKE_ACCESS';
      code?: string;
    };

function getChannel(): BroadcastChannelLike | null {
  if (typeof globalThis === 'undefined') {
    return null;
  }
  const ctor = (globalThis as { BroadcastChannel?: new (name: string) => any }).BroadcastChannel;
  if (typeof ctor !== 'function') {
    return null;
  }
  try {
    const instance = new ctor(CHANNEL_NAME);
    return instance as BroadcastChannelLike;
  } catch {
    return null;
  }
}

export function broadcastChildAccessEvent(event: ChildAccessEvent): void {
  const channel = getChannel();
  if (!channel) return;
  channel.postMessage(event);
  channel.close();
}

export function subscribeToChildAccessEvents(handler: (event: ChildAccessEvent) => void): () => void {
  const channel = getChannel();
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  if (!channel) return () => {};
  const listener = (event: BroadcastChannelMessageEvent) => handler(event.data as ChildAccessEvent);
  channel.onmessage = listener;
  return () => {
    if (channel.onmessage === listener) {
      channel.onmessage = null;
    }
    channel.close();
  };
}
